import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import buefy from "buefy";
import firebase from "./plugins/firebase";
import auth from "./plugins/auth";
import emitter from "./plugins/emitter";
import api from "./plugins/api";
import VueClipboard from "vue-clipboard2";

Vue.config.productionTip = false;
Vue.use(emitter);
Vue.use(firebase);
Vue.use(auth);
Vue.use(api);
Vue.use(buefy);
Vue.use(VueClipboard);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
